import { createSlice } from '@reduxjs/toolkit';
import { ScopeType } from '../utils';

interface IScopeState {
    currentScope: ScopeType;
}

const initialState: IScopeState = {
    currentScope: ScopeType.LLMChat,
}

const scopeSlice = createSlice({
    name: 'scope',
    initialState,
    reducers: {
        setCurrentScope(state, action) {
            state.currentScope = action.payload;
        },
        resetScopeState() {
            return initialState;
        }
    }
});

export const { 
    setCurrentScope,
    resetScopeState } = scopeSlice.actions;
export default scopeSlice.reducer;